<app-service-layout-v2
        [serviceParams]="{
            game: 'overwatch',
            service: 'divisions',
            type: 'solo',
            title: 'Rank Boosting',
            subtitle: 'Get your Desired Rank in Solo or Duo Boosting',
            start: 11,
            desired: 12
        }"
        [serviceFaqs]='[
            {
                question: "What Is A Division Elo Boost?",
                answer: "League of Legends Elo Boosting can take the form of a Division Boost, which guarantees that the player will achieve the desired rank."
            },
            {
                question: "What If You Demote Or Lose The Promotion Series?",
                answer: "We promise to deliver the contracted service. Therefore, if something like that were to occur, we would go beyond it and finish the service as planned."
            },
            {
                question: "Can I Play With The Booster In Duo Queue Boosting?",
                answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now.\""
            },
            {
                question: "Can I Choose My Preferred Champions/Roles And Summoner Spell Order?",
                answer: "Yes, you can. Click the \"Choose your Roles\" and \"Choose your Champions\" options in the order customization menu to make it happen."
            },
            {
                question: "Can I Play While The Order Is Active?",
                answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
            },
            {
                question: "Can I Request The Same Booster For A Future Purchase?",
                answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
            }
        ]'
        [currentServiceIcon]="'https://cdn.ggboost.com/images/services/apex/' + service + '.webp'"
        [availableServices]="availableServices"
></app-service-layout-v2>
